module.exports = __webpack_public_path__ + "images/FUSA_icons/014-barcode-1.faa1db1616eb98b04816278b5a0382f5.svg";